import { Button, message, Spin } from 'antd'
import { SBack, SMessage, SSteps } from 'shj-components'
import styles from '../../../index.module.less'
import { useEffect, useRef, useState } from 'react'
import Step1 from '../step1'
import Step2 from '../step2'
import Step3 from '../step3'
import Step3ForTemplate from '../step3/templateIndex'
import { CheckCircleOutlined } from '@ant-design/icons'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import {
  salePriceCheck,
  productManagementUpdateById,
  saveProduct,
  productManagementDetail,
  getArgList,
} from '@/services/product'
import { pushGoodsInitInfoByProdId } from '@/services/goods'
import { useStore, useAtomValue, useAtom, useSetAtom } from 'jotai'
import {step1DataAtom, step2DataAtom, step3DataAtom, stepCommonDataAtom} from '../store';
import {isArray} from "lodash-es";

export default function ProductSteps() {
  const [search] = useSearchParams()
  const activeTabKey = search.get('activeTabKey')
  const [current, setCurrent] = useState(0)
  const navigate = useNavigate()
  const stepRef1 = useRef<any>(null)
  const stepRef2 = useRef<any>(null)
  const stepRef3 = useRef<any>(null)
  const [saveProdId, setSaveProdId] = useState<any>('')
  const [btnLoading, setBtnLoading] = useState(false)
  const [showCreateFlag, setShowCreateFlag] = useState(false)
  const [paramList, setParamList] = useState<any>([]) // 原始数据
  const [filterParamList, setFilterParamList] = useState<any>([]) // 过滤后的数据
  const { id } = useParams() // 产品id

  const [step1Data, setStep1Data] = useAtom(step1DataAtom);
  const [step2Data, setStep2Data] = useAtom(step2DataAtom);
  const [step3Data, setStep3Data] = useAtom(step3DataAtom);
  const [stepCommonData, setStepCommonData] = useAtom(stepCommonDataAtom);

  useEffect(() => {
    // 获取参数接口
    getArgList({ enabled: true }).then((res: any) => {
      setParamList([...res])
      setFilterParamList([...res])
      if (id) {
        fetchDetail(id, res);
      } else {
        const mainFiles: any = [{
          url: 'https://static.shjmall.cn/standards/material.png',
          name: 'https://static.shjmall.cn/standards/material.png'.split('/')?.['https://static.shjmall.cn/standards/material.png'.split('/')?.length - 1],
          type: 'https://static.shjmall.cn/standards/material.png'.split('.')?.['https://static.shjmall.cn/standards/material.png'.split('.')?.length - 1] === 'png' ? 'image/png' : 'image/jpeg',
        }, {
          url: 'https://static.shjmall.cn/standards/work.png',
          name: 'https://static.shjmall.cn/standards/work.png'.split('/')?.['https://static.shjmall.cn/standards/work.png'.split('/')?.length - 1],
          type: 'https://static.shjmall.cn/standards/work.png'.split('.')?.['https://static.shjmall.cn/standards/work.png'.split('.')?.length - 1] === 'png' ? 'image/png' : 'image/jpeg',
        }]
        setStep1Data({
          ...step1Data,
          mainFiles,
        });
        stepRef1?.current?.formRef?.setFieldValue('mainFiles', mainFiles);
      }
    })
  }, []);
  const steps = [
    {
      title: '基础信息',
      content: (
        <Step1 ref={stepRef1} paramList={paramList} stepRef2={stepRef2}></Step1>
      ),
    },
    {
      title: '产品参数',
      content: (
        <Step2
          ref={stepRef2}
          paramList={paramList}
          filterParamList={filterParamList}
          setFilterParamList={setFilterParamList}
          current={current}
          showCreateFlag={showCreateFlag}
          setShowCreateFlag={setShowCreateFlag}
        ></Step2>
      ),
    },
    {
      title: '价格管理',
      content: (
        <>
          { ['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(step1Data.prodType) ? (
            <Step3ForTemplate ref={stepRef3}></Step3ForTemplate>
          ) : (
            <Step3 ref={stepRef3} current={current}></Step3>
          )}
        </>
      ),
    },
  ]
  const items = steps.map(item => ({ key: item.title, title: item.title }))

  const fetchDetail = async (id: any, list: any) => {
    try {
      const res: any = await productManagementDetail(id);
      if (res.id) {
        const oneData: any = {};
        const twoData: any = {};
        const threeData: any = {};
        const commonData: any = {};
        const config = dataToForm(res.specificationArgList, true, res.prodType, list);
        const notStandardConfig = dataToForm(res.argList, false, res.prodType, list);

        res.skuList = res.skuList?.map(sku => {
          const obj = {};
          Object.keys(sku?.argMap)?.forEach((arg) => {
            obj[arg] = sku?.argMap?.[arg]?.valueName;
          });
          return {
            ...sku,
            ...obj,
            ...(sku.skuPrice || {})
          }
        })

        Object.keys(step1Data).forEach(key => {
          oneData[key] = res[key];
        })
        Object.keys(step2Data).forEach(key => {
          twoData[key] = res[key];
        })
        Object.keys(step3Data).forEach(key => {
          threeData[key] = res[key];
        })
        Object.keys(stepCommonData).forEach(key => {
          commonData[key] = res[key];
        })

        const mainFiles: any = res?.imageUrls?.map(item => ({
          url: item,
          name: item.split('/')?.[item.split('/')?.length - 1],
          type: item.split('.')?.[item.split('.')?.length - 1] === 'png' ? 'image/png' : 'image/jpeg',
        }));
        const attachList: any = res?.attachList?.map((attach: any, index: number) => {
          let subBusType = ''
          switch (attach.contentType) {
            case 'attachContent':
              subBusType = 'TYPE_TXT'
              break
            case 'attachPDF':
              subBusType = 'TYPE_PDF'
              break
            case 'attachVideo':
              subBusType = 'TYPE_VIDEO'
              break
            case 'attachURL':
              subBusType = 'TYPE_DESIGN'
              break
            default:
              subBusType = ''
              break
          }
          return {
            ...attach,
            subBusType,
            contentInfo: attach.content,
            name: attach.attachName,
            key: index
          }
        })
        const newList = stepRef1?.current?.getInfo?.(attachList);
        // 处理图片和详情文件，给打包模板初始值
        oneData['mainFiles'] = mainFiles;
        oneData['attachList'] = newList;
        oneData['packModelId'] = oneData.packModelId || '';

        stepRef1?.current?.formRef?.setFieldsValue({
          ...oneData
        });

        // 费用项
        if (!['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(res.prodType)) {
          stepRef3?.current?.setData?.(oneData['skuList'])
        }

        if (oneData.priceItems?.length) {
          const priceItemList = oneData.priceItems?.map(price => ({
            ...price,
            level: 1
          }))
          oneData.priceItems = [...priceItemList];
        }

        // 规格参数
        const skuTableColumns = res.specificationArgList?.filter(item => item.argType === 'CHOOSE')?.map(item => {
          if (item.values?.length > 0) {
            setShowCreateFlag(true)
          }
          return { dataIndex: item.argCode, title: item.argName }
        })

        // 选品默认展示sku
        if (id && oneData.sourceType !== 'SELF') {
          setShowCreateFlag(true);
        }

        setStep1Data({
          ...oneData,
        });
        setStep2Data({
          ...twoData,
          config,
          notStandardConfig,
          skuTableColumns,
        });
        setStep3Data({
          ...threeData,
        });
        setStepCommonData({
          ...stepCommonData,
          ...commonData,
        });
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 参换转表单渲染
  const dataToForm = (list, isSpec = true, prodType, paramList) => {
    const newConfig: any = [{
      formItem: []
    }];

    list.forEach(item => {
      const isPackage = ['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(prodType)
      if (isPackage && isSpec) {
        item.forBidDelete = true
      } else {
        item.forBidDelete = false
      }
      if (isSpec) {
        // 带出规格参数的值
        stepRef2?.current?.step2FormRef.setFieldValue(
          item.argCode,
          item.values?.length
            ? [...item.values?.map(item => item.valueId)]
            : undefined,
        )
      } else {
        // 带出非规格参数的值
        stepRef2?.current?.step2UnFormRef.setFieldValue(
          item.argCode,
          item.values?.length
            ? [...item.values?.map(item => item.valueId)]
            : undefined,
        )
      }
        
      const current = paramList.find(arg => arg.argCode === item.argCode) || item || {}

      newConfig[0].formItem.push({
        ...item,
        label: item.argName,
        name: item.argCode,
        spanCol: 24,
        required: item.argType === 'CHOOSE' ? true : false,
        options: current,
        type: item.argType,
      })
    })

    return newConfig;
  }

  const handleSteps = async (e: any, type?: string) => {
    console.log(e, 'step')
    if (e < 0 || e > 2) return
    if (e === 1) {
      if (type !== 'back') {
        // 第一步保存
        try {
          await stepRef1.current?.onSubmit();
        } catch (err) {
          return;
        }
      }
      setCurrent(e)
    } else if (e === 2) {
      if (type !== 'back') {
        // 第二步保存
        try {
          await stepRef2.current?.onSubmit()
        } catch (err) {
          return;
        }
      }
      setCurrent(e)
    } else if (e === 0) {
      // 第三步保存
      setCurrent(e)
    }
  }
  const onSaveData = async () => {
    const step3FormData = await stepRef3.current?.onFormSubmit?.() || {}
    if(step3FormData.err) {
      return;
    }
    setBtnLoading(true)
    console.log(step1Data, 'step1Info')
    console.log(step2Data, 'step2Data')
    console.log(step3FormData, step3Data, 'step3Data')
    console.log(stepRef3, 'stepRef3')
    try {
      if (!id) {
        if (!['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(step1Data.prodType)) {
          const skuList = stepRef3?.current?.data?.map(item => ({
            ...item,
            skuPrice: {
              buyPrice: item.buyPrice,
              saleType: item.saleType,
              saleTypeName: item.saleTypeName,
              salePrice: item.salePrice,
              gpAmount: item.gpAmount
            },
          }))
          const res: any = await saveProduct({
            ...step1Data,
            ...step2Data,
            skuList,
            mainFiles: [],
            config: [],
            skuByArgs: [],
            skuTableColumns: []
          })
          if (res.id) {
            setSaveProdId(res.id);
            message.success('保存成功')
            setCurrent(current + 1)
          }
        } else {
          if (!step1Data.priceItems?.length) {
            message.error('未添加费用项');
          }
          const checkPriceRe = (list: any) => {
            list?.forEach((price: any) => {
              if (price.mathTypeStr === '特定项选材客户价合计' && !price?.nodeIds?.length) {
                throw new Error(`报价类型：${price?.quoteTypeName}，费用项：${price?.itemName}，未勾选特定打包项`);
              }
              if (price.children?.length) {
                checkPriceRe(price.children)
              }
            })
          }
          checkPriceRe(step1Data.priceItems)
          const res: any = await saveProduct({
            ...step1Data,
            ...step2Data,
            ...step3FormData,
            mainFiles: [],
            config: [],
            skuByArgs: [],
            skuTableColumns: []
          })
          if (res.id) {
            setSaveProdId(res.id);
            message.success('保存成功')
            setCurrent(current + 1)
          }
        }
      } else {
        if (!['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(step1Data.prodType)) {
          const skuList = stepRef3?.current?.data?.map(item => ({
            ...item,
            skuPrice: {
              buyPrice: item.buyPrice,
              saleType: item.saleType,
              saleTypeName: item.saleTypeName,
              salePrice: item.salePrice,
              gpAmount: item.gpAmount
            },
          }))
          const res: any = await productManagementUpdateById({
            id,
            ...step1Data,
            ...step2Data,
            ...step3FormData,
            skuList,
            mainFiles: [],
            config: [],
            skuByArgs: [],
            skuTableColumns: []
          })
          if (res.id) {
            setSaveProdId(res.id);
            message.success('保存成功')
            setCurrent(current + 1)
          }
        } else {
          if (!step1Data.priceItems?.length) {
            message.error('未添加费用项');
          }
          const checkPriceRe = (list: any) => {
            list?.forEach((price: any) => {
              if (price.mathTypeStr === '特定项选材客户价合计' && !price?.nodeIds?.length) {
                throw new Error(`报价类型：${price?.quoteTypeName}，费用项：${price?.itemName}，未勾选特定打包项`);
              }
              if (price.children?.length) {
                checkPriceRe(price.children)
              }
            })
          }
          checkPriceRe(step1Data.priceItems)
          const res: any = await productManagementUpdateById({
            id,
            ...step1Data,
            ...step2Data,
            ...step3FormData,
            mainFiles: [],
            config: [],
            skuByArgs: [],
            skuTableColumns: []
          })
          if (res.id) {
            setSaveProdId(res.id);
            message.success('保存成功')
            setCurrent(current + 1)
          }
        }
      }
      setBtnLoading(false);
    } catch (err: any) {
      setBtnLoading(false);
      message.error(err?.message || '操作失败');
    }
  }

  const goBack = () => {
    SMessage.confirm({
      title: '确认继续返回',
      content: '返回将不会保存已添加信息',
      onOk: () => {
        navigate('/config/productManage' + (activeTabKey ? `?activeTabKey=${activeTabKey}` : '' ), { state: { saveCache: true }});
      },
    })
  }

  const extraRender = () => {
    if (current > 2) return
    return [
      <Button style={{ marginRight: '10px' }} onClick={goBack}>
        取消
      </Button>,
      current > 0 && (
        <Button style={{ marginRight: '10px' }} onClick={() => handleSteps(current - 1, 'back')}>
          上一步
        </Button>
      ),
      current < 2 && (
        <Button type="primary" onClick={() => handleSteps(current + 1)}>
          下一步
        </Button>
      ),
      current === 2 && (
        <Button type="primary" onClick={onSaveData}>
          保存
        </Button>
      ),
    ]
  }
  // 发布
  const onPublicProduct = async () => {
    try {
      await salePriceCheck(saveProdId);
    } catch (err) {
      message.info('无销售指导价，不能发布');
      return;
    }
    pushGoodsInitInfoByProdId(saveProdId).then(res => {
      if (res && res.id) {
        navigate(`/config/commodityManage/commodityEdit/${res.id}`)
      }
    })
  }
  return (
      <SBack title={id ? '编辑产品' : '新增产品'} level={2} extra={extraRender()} goPath={goBack}>
        <Spin spinning={btnLoading}>
          <div className={styles.baseBox}>
            {current < 3 && (
              <div className={styles.step_wrap}>
                <SSteps
                  className={styles.productSteps}
                  // size="small"
                  // labelPlacement="vertical"
                  current={current}
                  items={items}
                  style={{ width: 600, margin: '0 auto' }}
                />
              </div>
            )}
            {steps.map((item, index) => (
              <div style={{ display: current === index ? 'block' : 'none' }}>
                {item?.content}
              </div>
            ))}
            {/* 成功页面*/}
            {current > 2 && (
              <div className={styles.successBox}>
                <div>
                  <p style={{ textAlign: 'center', fontSize: '30px', color: '#1890ff' }}>
                    <CheckCircleOutlined />
                  </p>
                  <p style={{ margin: '20px 0', textAlign: 'center' }}>产品创建成功</p>
                  <p>
                    <Button
                      style={{ marginRight: '20px' }}
                      onClick={() => {
                        navigate('/config/productManage'+ (activeTabKey ? `?activeTabKey=${activeTabKey}` : '' ))
                      }}
                    >
                      返回
                    </Button>
                    <Button type="primary" onClick={onPublicProduct}>
                      去发布商品
                    </Button>
                  </p>
                </div>
              </div>
            )}
          </div>
        </Spin>
      </SBack>
  )
}
